module.exports = __webpack_public_path__ + "static/media/Relicanth_gaussian2.9bf4b73f.png";